import { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useDashboardAnalytics = (
  userID,
  interval,
  platform,
  {
    enableDashboard = true,
    enableOrderAnalytics = true,
    enableBestSelling = true,
   enableRestaurantAnalytics = false,
  } = {},
  refreshKey = 0
) => {
  const { api } = useContext(GlobalContext);

  const [dashboardData, setDashboardData] = useState({});
  const [orderAnalytics, setOrderAnalytics] = useState([]);
  const [topOrders, setTopOrders] = useState([]);
  const [topOrdersAnalytics, setTopOrdersAnalytics] = useState([]);
const [loading, setLoading] = useState(false);
const [restaurantAnalyticsLoading, setRestaurantAnalyticsLoading] = useState(false);
const [restaurantAnalytics, setRestaurantAnalytics] = useState([]);
const [restaurantAnalyticsDuration, setRestaurantAnalyticsDuration] = useState(null);

  /* ---------------- Dashboard Analytics ---------------- */

  const fetchDashboardAnalytics = async () => {
    try {
      setLoading(true);

    const res = await api.post(
  "/Whatsapp/getDashboardAnalytics",
  { userid: userID, interval }
);

      if (res?.data?.responseCode === "00") {
        setDashboardData(res.data.data || {});
      }
    } catch (err) {
      console.error("Dashboard API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- Order Analytics ---------------- */

  const fetchOrderAnalytics = async () => {
    try {
      setLoading(true);

     const res = await api.post(
  "/Order/getOrderAnalyticsData",
  { userid: userID, interval }
);

      if (res?.data?.responseCode === "00") {
        setOrderAnalytics(res.data.response || []);
      }
    } catch (err) {
      console.error("Order Analytics API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- Best Selling Products ---------------- */

  const fetchBestSellingProducts = async () => {
    try {
      setLoading(true);

     const res = await api.post(
  "/Order/v1.0/getBestSellingProducts",
  { userid: userID, interval, platform }
);

      if (res?.data?.responseCode === "00") {
        const data = res.data.response || [];

        setTopOrders(data.slice(0, 5));
        setTopOrdersAnalytics(data);
      }
    } catch (err) {
      console.error("Best Selling API Error:", err);
    } finally {
      setLoading(false);
    }
  };

const fetchRestaurantAnalytics = async () => {
  const requestedDuration = interval;

  try {
    setRestaurantAnalyticsLoading(true);
    setRestaurantAnalytics([]);
    setRestaurantAnalyticsDuration(null);

    const res = await api.post(
  "/Order/getRestaurantWiseOrderAnalytics",
  {
    fk_user_id: userID,
    duration: requestedDuration,
  }
);

    if (res?.data?.responseCode === "00") {
      setRestaurantAnalytics(res.data.response || []);
      setRestaurantAnalyticsDuration(requestedDuration);
    } else {
      setRestaurantAnalytics([]);
      setRestaurantAnalyticsDuration(requestedDuration);
    }
  } catch (err) {
    console.error("Restaurant Analytics API Error:", err);
    setRestaurantAnalytics([]);
    setRestaurantAnalyticsDuration(requestedDuration);
  } finally {
    setRestaurantAnalyticsLoading(false);
  }
};

  /* ---------------- useEffects ---------------- */

  useEffect(() => {
    if (!userID || !enableDashboard) return;
    fetchDashboardAnalytics();
}, [userID, interval, refreshKey]);

  useEffect(() => {
    if (!userID || !enableOrderAnalytics) return;
    fetchOrderAnalytics();
}, [userID, interval, refreshKey]);

  useEffect(() => {
    if (!userID || !enableBestSelling) return;
    fetchBestSellingProducts();
 }, [userID, interval, platform, refreshKey]);

useEffect(() => {
  if (!userID || !enableRestaurantAnalytics) return;
  fetchRestaurantAnalytics();
}, [userID, interval, enableRestaurantAnalytics, refreshKey]);

return {
  dashboardData,
  orderAnalytics,
  topOrders,
  topOrdersAnalytics,
  restaurantAnalytics,
  restaurantAnalyticsLoading,
  restaurantAnalyticsDuration,
  loading,
};
};

export default useDashboardAnalytics;